import { PromptBlueprint } from "@/types/prompt-blueprint";
import { useMutation } from "@tanstack/react-query";
import { dataToPromptBlueprint } from "./utils";
import { displayErrorToast } from "@/utils/toast";

export const useAIPromptAssisstant = () => {
  return useMutation(
    async ({
      prompt,
      blueprint,
    }: {
      prompt: string;
      blueprint: Partial<PromptBlueprint>;
    }) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        displayErrorToast(
          "Oh no! The AI prompt assistant is taking too long to respond. Please try again.",
        );
      }, 35000);

      try {
        const response = await fetch(
          "https://hook.us1.make.com/9teowog7bslthsy30xju8rynk4v8s53c",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              prompt_blueprint: JSON.stringify(blueprint),
              customer_prompt: JSON.stringify(prompt),
            }),
            signal: controller.signal,
          },
        );

        const data = await response.json();

        if (data.generation_error) {
          displayErrorToast(data.generation_error);

          return null;
        }

        return dataToPromptBlueprint(data);
      } finally {
        clearTimeout(timeoutId);
      }
    },
  );
};
